<template>
    <div class="recharge_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()">
                <van-icon name="arrow-left"/>
            </div>
            <div class="big_tit">{{ $t('lang.USDT地址管理') }}</div>
        </div>
        <div class="cont">
            <div class="wrap_box warp1">
                <p>{{ $t('lang.我的USDT提出地址') }}<span>({{ allNum }})</span></p>
            </div>
            <div class="wrap_box warp2">
                <div class="item" v-for="i in data.bank">
                    <img :src="require('../images/user/recharge'+i.type+'.png')" alt="">
                    <div class="item_detail">
                        <p class="user_name ari_font">{{ i.bank }}</p>
                        <p class="user_num">{{ i.account }}</p>
                    </div>
                    <div class="del" @click="delCard(i.id)">
                        <van-icon name="delete-o"/>
                    </div>
                </div>
            </div>
            <van-button class="addBtn" @click="addAddress" block
                        color="linear-gradient(0deg,#B38C70 0%,#EAD8C6 100%)">{{ $t('lang.添加提币地址') }}
            </van-button>
            <div class="tips">{{ $t('lang.maxAddress') }}</div>
        </div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch'


export default {
    name: "account",
    data() {
        return {
            allNum: 0,
            data: {}
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.start();
    },
    methods: {
        addAddress() {
            if (this.allNum > 5) {
                this.$toast(this.$t('lang.maxAddress'));
                return;
            }
            this.$router.push('/addcountUsdt')
        },
        delCard(id) {
            Fetch('/user/bank_remove', {id: id}).then(() => {
                this.start()
            });
        },
        start() {
            Fetch('/user/my_bank').then(r => {
                this.data = r.data;
                this.allNum = r.data.count;
            })
        }
    }
};
</script>

<style lang="less" scoped>
.red_top_bg {
  background: rgb(35, 29, 29) !important;
  color: rgb(239, 216, 196) !important;

  .big_tit {
    color: rgb(239, 216, 196) !important;
  }
}

.cont {
  height: calc(100vh - 44px);
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
  padding: 12px;

  .wrap_box {
    background: transparent;
    box-shadow: none !important;
    color: #f1ded5 !important;
  }

  .addBtn {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    color: #0f0f10 !important;
  }

  .tips {
    font-size: .71875rem;
    color: #bebdbe;
    text-align: center;
    margin-top: 20px;
  }
}

.warp1 {
  padding: 0 20px;
  height: 40px;

  p {
    font-size: 14px;
    line-height: 40px;
    font-weight: bold;
    color: #f1ded5 !important;

    span {
      color: #F03041;
    }
  }
}

.ari_font {
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, .8);
  line-height: 20px;
}

.warp2 {
  padding: 0 15px;
  margin-top: 12px;
  background: #4D4141 !important;

  .item {
    padding: 14px 0 11px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #ECECEC;

    &:last-child {
      border-bottom: none;
    }

    img {
      width: 30px;
      height: 30px;
    }

    .item_name {
      width: 65px;
    }

    .item_detail {
      margin-left: 10px;
    }

    .user_num {
      height: 17px;
      font-size: 12px;
      font-weight: 600;
      color: rgba(0, 0, 0, .6);
      line-height: 17px;
      margin-top: 10px;
    }

    .del {
      width: 20px;
      height: 20px;
      margin: 0 8px 0 auto;
    }
  }
}

.basic_btn {
  margin: 50px auto 0 auto;
}
</style>
